import { render } from "./NewDonorApheresisPamphletMobile.vue?vue&type=template&id=270a4d23"
import script from "./NewDonorApheresisPamphletMobile.vue?vue&type=script&lang=js"
export * from "./NewDonorApheresisPamphletMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__